import { useQuery } from '@tanstack/react-query';
import type { CreditBalanceInfo } from '~/queries/subscription';

export const useCreditBalance = () => {
  const { data, isLoading } = useQuery<CreditBalanceInfo>({
    queryKey: ['creditBalance'],
    queryFn: async () => {
      const response = await fetch('/credit-balance-api', { credentials: 'include' });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    },
    staleTime: 5 * 60 * 1000,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });

  return {
    credits: data?.credits ?? null,
    grantedCredits: data?.grantedCredits ?? null,
    topupCredits: data?.topupCredits ?? 0,
    isLoading,
  };
};
